module.exports = __webpack_public_path__ + "media/logos/yanosik-autoplac-logo-85d253a3.svg";